function openPopup(button) {
    const popup = button.querySelector('.js_vehicleCard__saving__infoPopup');

    if (popup) {
        popup.classList.add('vehicleCard__saving__infoPopup--open');
    }
}

function closePopup(e, button) {
    e.stopPropagation();
    const popup = button.closest('.js_vehicleCard__saving__infoPopup');

    if (popup) {
        popup.classList.add('whatisgoingon');
        popup.classList.remove('vehicleCard__saving__infoPopup--open');
    }
}

export function initInfoPopup() {
    const openButtons = [...document.querySelectorAll('.js_vehicleCard__saving__infoButton')];
    const closeButtons = [...document.querySelectorAll('.js_vehicleCard__saving__closeButton')];

    openButtons.forEach(button => button.addEventListener('click', e => openPopup(button)));
    closeButtons.forEach(button => button.addEventListener('click', e => closePopup(e, button)));
}

$(document).ready(initInfoPopup);
